import React from "react";
import { AUDIENCES, REQUIREMENTS, IMAGES } from "../data/content";
import ProductImage from "./ProductImage";
import "../styles/about.css";

function AboutContent() {
  return (
    <section className="about section" id="about-content">
      <div className="container about-grid">
        <div className="about-copy">
          <h2 className="section-title">
            Designed around attendance, built for the whole organization
          </h2>
          <p className="section-subtitle about-lead">
            MPeoples HRMS is a mobile-based Human Resource Management System
            designed to simplify and digitize employee attendance and
            day-to-day HR activities, with a companion Web based Admin
            Dashboard for HR and management.
          </p>

          <div className="about-reqs">
            <h3 className="about-reqs-title">Built for everyday conditions</h3>
            <ul className="about-reqs-list">
              {REQUIREMENTS.map((req) => (
                <li key={req}>{req}</li>
              ))}
            </ul>
          </div>

          {/* <ProductImage
            src={IMAGES.aboutDashboardWide}
            alt="MPeoples HRMS Admin Dashboard"
            frame="wide"
            className="about-image"
          /> */}
        </div>

        <div className="about-audiences">
          <h3 className="about-audiences-title">Who it&rsquo;s built for</h3>
          {AUDIENCES.map((aud) => (
            <div className="about-audience-item" key={aud.title}>
              <h4>{aud.title}</h4>
              <p>{aud.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutContent;
